module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-06.af50db13.jpg";